function lbaFareClassTypeSelect() {
  return {
    restrict: 'A',
    scope: {
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaFareClassTypeSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaFareClassTypeSelect.html')
  }
};

export default lbaFareClassTypeSelect;



// WEBPACK FOOTER //
// ./src/components/lbaFareClassTypeSelect/lbaFareClassTypeSelectDir.js